export const CircleQuestionMark = () => {
	return (
		<svg
			width="16"
			height="17"
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect
				y="0.5"
				width="16"
				height="16"
				rx="8"
				fill="#8F9DAE"
			/>
			<path
				d="M5.6792 6.82431C5.67856 6.38662 5.8017 5.95767 6.0344 5.58696C6.2671 5.21626 6.59988 4.91891 6.99435 4.72924C7.38882 4.53957 7.82887 4.46531 8.26373 4.51502C8.69859 4.56474 9.1105 4.7364 9.45195 5.01021C9.79347 5.28402 10.0505 5.6488 10.1936 6.06246C10.3366 6.47612 10.3598 6.92179 10.2603 7.34806C10.1609 7.77432 9.94298 8.16377 9.63171 8.47145C9.32044 8.77913 8.92852 8.99254 8.50114 9.08706C8.36097 9.11471 8.23454 9.18974 8.14305 9.29954C8.05162 9.40934 8.00071 9.54728 7.99886 9.69017V10.3786"
				stroke="white"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle
				cx="7.999"
				cy="11.9861"
				r="0.513893"
				fill="white"
			/>
		</svg>
	);
};
